
import {
  IonApp,
  IonContent,
  IonList,
  IonListHeader,
  IonMenu,
  IonNote,
  IonRouterOutlet,
  IonIcon,
  IonSplitPane,
  IonLabel,
  modalController,
  IonItem
} from '@ionic/vue';
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import { logOut } from 'ionicons/icons';
import LoginPage from './views/Login/LoginPage.vue';
//import { loginUitlity } from './views/LoginUtility'

import { LoginUtility } from './views/LoginUtility/LoginUtility'
import { useApplicationStore } from './stores/ApplicationStore';

export default defineComponent({
  name: "AppPage",
  components: {
    IonApp,
    IonContent,
    IonList,
    IonListHeader,
    IonMenu,
    IonNote,
    IonRouterOutlet,
    IonSplitPane,
    IonIcon,
    IonLabel,
    IonItem

  },
  setup() {
    const router = useRouter();



    const openLogin = async () => {
      //effettua un logout
      const login = new LoginUtility()
      router.push('/homepage');
      login.LogOut();


      //visualizza il modal di login
      const modal = await modalController.create({
        component: LoginPage, //Modal is name of the component to render inside ionic modal
        cssClass: 'fullscreen',
        canDismiss: canDismiss,

      });

      await modal.present();

      // modal.onDidDismiss().then(

      //);

    };

    async function canDismiss() {
      const appStore = useApplicationStore();
      return appStore.$APP_READY;
    }

    return { router, logOut, openLogin, };  //canDismiss
  },
  methods: {


    openRoute(nomeRoute: string) {
      if (nomeRoute == 'etichette') {

        this.$router.push('/etichetteApp/tab2');

      } else if (nomeRoute == 'insordini') {

        this.$router.push('/insOrdini');

      } else if (nomeRoute == 'AnagraficaClienti') {

        this.$router.push('/AnagraficaClienti');

      } else if (nomeRoute == 'AnagraficaProdotti') {

        this.$router.push('/AnagraficaProdotti');
      }
    }
  }
})


